import dayjs from "dayjs";
import {EMPTY_UI} from "../variables";

export enum DateFormat {
    DATE = "YYYY-MM-DD",
    DATE_HOURS_MINUTES = "YYYY-MM-DD HH:mm",
    DATE_HOURS_MINUTES_SECONDS = "YYYY-MM-DD HH:mm:ss",
    MONTH_YEAR = "MMMM, YYYY",
    DAY_MONTH_YEAR = "DD MMMM, YYYY",
    HOURS_MINUTES = "HH:mm A",
    MONTH_YEAR_NUMBER = "MM/YYYY",
    DATE_TIME_REQUEST = "YYYY-MM-DDTHH:mm:ss",
    DATE_TIME_UTC_Z = "YYYY-MM-DDTHH:mm:ss[Z]",
    DATE_LOCALIZED = "LL",
    DATE_LOCALIZED_TIME = "LLL",
}

export enum DateUnitType {
    SECOND = "second",
    MINUTE = "minute",
    DAY = "day",
    WEEK = "week",
    MONTH = "month",
    YEAR = "year",
}

export function formatTimestamp(value: any, format = DateFormat.DATE_HOURS_MINUTES): string {
    return value ? dayjs(value).format(format) : EMPTY_UI;
}
